export default __webpack_public_path__ + "static/media/Home-foto-header-partners-Tower-viajes-mobile@3x.73ff9f81.jpg";